import React, { useState , useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/material/styles';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';

import CenterEditor from './CenterEditor';

import { ClockLoader } from 'react-spinners';
//https://mui.com/material-ui/maexecuterial-icons/?query=reset

// !!!! important is need to install for ignore fs path and crypto requirements
// yarn add react-app-rewired --save-dev 
// and config-overrides.js 
// link https://github.com/timarney/react-app-rewired

import FastSAMImageList from './ImagesList';
import VisuallyHiddenInput from './VisuallyHiddenInput';
import Portrait from './Portrait';
import InpaintEditor from './InpaintEditor';
import { SignalWifiConnectedNoInternet4 } from '@mui/icons-material';

import Iframe from 'react-iframe';

//import cv from '@techstark/opencv-js'

// For typescript example see: https://github.com/musama619/react-photo-editor/blob/main/src/examples/CustomPhotoEditor.tsx

var canvdrawref;

//const IMAGESERVICEURL = "http://localhost:8181/cxf/eyeprocessor/";
const IMAGESERVICEURL = "https://eyeprocessorsite.affarintech.com/eyeprocessor/";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));



const inline = {
  div:{
    display: "inline-flex"
  }
}

const SinglePage = (prop) => {

  const [busy, setBusy] = useState(false);
  const [file, setFile] = useState();
  const [mode, setMode] = useState();
  const [center, setCenter] = useState();
  const [objects, setObjects] = useState();
  const [imageselect, setImageSelect] = useState();
  
  const [waitpatch, setWaitPatch] = useState();

  const setFileData = (e) => {
    if (e?.target?.files && e.target.files.length > 0) {
      console.log(e.target.files[0]);
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("name", e.target.files[0].name );
      setBusy(true);
      fetch(IMAGESERVICEURL+"testfastsam", {
        method: "POST", 
        body: formData
      }).then((response) => response.json())
        .then((data) => {
          setBusy(false); 
          console.log(data);
          setObjects(parseInt(data.objects));
      }).catch( e => {
        setBusy(false);
        console.log("error on upload");
      });
    }
  };

  useEffect(()=>{
    console.log("load image");
  },[mode]);

  useEffect(()=>{
      let md = prop.mode.split("/")[1];
      setMode(md);
      console.log(md);
  },[prop]);

  useEffect(()=>{
    if(objects!==undefined)
      console.log("there is "+objects+" in image");
  },[objects])

  useEffect(()=>{
    if(imageselect!==undefined){
      console.log("selected image ",imageselect);
      setMode("Center_Image");
    }
  },[imageselect])

  function drawImage(){
    let sr = IMAGESERVICEURL+"/lastfastsam/image/"+imageselect;
    return <div><img src={sr}  class="baseimage"/></div> 
  }

  function imgs(){
    const a = [...Array(objects).keys()].map(i =>{
      let sr = IMAGESERVICEURL+"/lastfastsam/thumbimage/"+i;
      return <div><img 
          src={sr} 
          class="thumbnail"
          onClick={()=>setImageSelect(i)}
          /></div>  
    //return "http://127.0.0.1:8181/cxf/eyeprocessor/lastfastsam/thumbimage/"+i;
      });
      return a;
  }

  function loadButton(){
    if(prop.mode.endsWith('Load_Image')){
      return (
              <Button component="label" tabIndex={-1} role={undefined} variant="contained" startIcon={<FileUploadIcon/>}>Load
                <VisuallyHiddenInput type="file" onChange={(e) => setFileData(e)} multiple={false} />
              </Button>)}
    else {
      return (<span></span>);
    }
  }

  async function toDataURL(url) {
    const blob = await fetch(url).then(res => res.blob());
    return URL.createObjectURL(blob);
  }
  async function downloadImage(){
    //const url = window.URL.createObjectURL(imageBlob);
    const a = document.createElement('a');
    a.style.display = 'none';
    //if(blob==null)
    a.href = await toDataURL(IMAGESERVICEURL+"/lastfastsam/thumbimage/"+imageselect);
    a.download = 'selected.png';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

 

  const centercb = (id)=>{
    if(id===undefined)
      return;
    console.log("center callback for "+id);
    setCenter(id);

     
    //setWaitPatch(wi);
  };

  function pushButton(){
    if(prop.mode.endsWith('Show_portrait')){
      return (<Portrait/>);
    }
    if(imageselect!==undefined){
      return (<div class="horizontal">
          <Button component="label" tabIndex={-1} onClick={downloadImage} role={undefined} color={'secondary'} variant="contained" startIcon={<DownloadIcon/>}>Donwload</Button></div>);
    }

    return(<span></span>);
  }

  //<!--<Button component="label"  color={'secondary'} tabIndex={-1} role={undefined} variant="contained" startIcon={<FileUploadIcon/>}>Clear</Button>-->
  //<Iframe  url="https://gmicol.greyc.fr/" width="1280" height="1280"/>         
  return (
    <Grid container spacing={2}>
      <Grid size={5}>
        <h5>{prop.mode}</h5>
        {pushButton()}      
        {!busy && (<FastSAMImageList objects={objects} clickfn={setImageSelect} selectedimg={imageselect} />)}
        {imageselect === undefined && busy && (<ClockLoader color="#21ca1c" />)}
        {imageselect === undefined && objects === undefined && !busy && (loadButton())}
        <CenterEditor dim={1024} show={imageselect} callback={centercb} />
        <InpaintEditor dim={1024} show={center} />
        {false && (<Iframe url="https://gmicol.greyc.fr/" width="1280" height="1280"/> )}        
        
      </Grid>
    </Grid>
  );
  
};


export {IMAGESERVICEURL, SinglePage};
